var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex py-2 px-3 w-full"},[_c('p',{staticClass:"w-full"},[_c('label',{staticClass:"text-sm block w-full font-semibold"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"opacity-75 text-sm block w-full capitalize"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"text-sm"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }